import { useApiPost } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function useDisableImpersonationMode() {
  const apiPost = useApiPost<any>();

  return useMutation({
    mutationFn: () => {
      return apiPost('/impersonation/v2/x4c/disable', {});
    },
    onSuccess: () => {
      window.location.reload();
    },
  });
}
